import { render } from "./infoPanel.vue?vue&type=template&id=b9c77d90&scoped=true&ts=true"
import script from "./infoPanel.vue?vue&type=script&lang=ts"
export * from "./infoPanel.vue?vue&type=script&lang=ts"

import "./infoPanel.vue?vue&type=style&index=0&id=b9c77d90&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9c77d90"]])

export default __exports__